import { extent } from 'd3-array';
import _flatten from 'lodash/flatten';
import _keys from 'lodash/keys';

export const minRadius = 3;
export const maxRadius = 90;
export const labelMinRadius = 15;

export const minTickSize = 10;
export const maxTickSize = 12;

export const toggleButtonPrefix = 'toggle-button';
export const separateButtonPrefix = 'separate-button';

export const groupTitleLeft = 'World Class Patents';
export const groupTitleRigth = 'Other Patents';

export const separateTitleTextOpacity = 0.6;

export function getDomain(data, year) {
  let result;
  if (year) {
    result = data.map(obj => +obj[year]);
  } else {
    const years = _keys(data[0]).filter(d => +d);
    const allValues = data.map(obj => years.map(key => (obj[key] ? +obj[key] : undefined)).filter(d => d));
    result = _flatten(allValues);
  }

  return extent(result);
}

export const wrapLabel = (str, context, maxWidth) => {
  const words = str.split(' ');
  let text = `${words[0]} `;
  const result = [];
  words.forEach((d, i) => {
    if (i === 0) return;
    const w = context.measureText(text).width;
    if (w > maxWidth) {
      result.push(text);
      text = `${d} `;
    } else text += `${d} `;
  });
  result.push(text.trim());
  return result;
};

export function dist(x1, y1, x2, y2) {
  return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1) );
}

export const guid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};
